import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import centerService from "services/center-service";
import Notification from "examples/Notifications";
import { useParams } from "react-router-dom";
import { FormControl, IconButton, InputLabel, MenuItem, Select } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

const CenterForm = forwardRef(({ initialData, type }, ref) => {
  const { id } = useParams();
  const [center, setCenter] = useState({
    ...initialData,
    city: initialData.city || "Lahore",
    country: initialData.country || "Pakistan",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(false);

  const cityOptions = ["Lahore", "Karachi", "Islamabad", "Sailkot"];
  const countryOptions = ["Pakistan"];

  useEffect(() => {
    setCenter({
      ...initialData,
      city: initialData.city || "Lahore",
      country: initialData.country || "Pakistan",
    });
  }, [initialData]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    const updatedCenter = { ...center, [name]: value };
    setCenter(updatedCenter);
  };

  const validate = () => {
    const newErrors = {};
    if (!center.name?.trim()) newErrors.nameerror = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitHandler = async (e) => {
    if (e) e.preventDefault();
    if (!validate()) return;

    const centerData = {
      ...center,
      city: center.city || "Lahore",
      country: center.country || "Pakistan",
    };

    await handleSubmit(centerData);
  };

  const handleSubmit = async (centerData) => {
    setLoading(true);
    let response;
    if (type === "create") {
      response = await centerService.create(centerData);
    } else {
      response = await centerService.update(id, centerData);
    }
    setLoading(false);

    if (response.success) {
      setNotification({ type: "success", message: response.message });
    } else {
      setNotification({ type: "error", message: response.errors[0] });
    }
  };
  useImperativeHandle(ref, () => ({
    submitHandler,
    resetForm: () => {
      setCenter({
        name: "",
        email: "",
        address: "",
        city: "Lahore",
        country: "Pakistan",
      });
      setErrors({});
      setNotification(false);
    },
  }));

  return (
    <MDBox component="form" role="form" onSubmit={submitHandler} display="flex" flexDirection="column" py={0} px={3}>
      <Notification notification={notification} setNotification={setNotification} />
      <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
        <MDBox width="100%" mr={2}>
          <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">Title</MDTypography>
          <MDInput type="text" fullWidth name="name" value={center.name} onChange={changeHandler} error={errors.nameerror} />
          {errors.nameerror && <MDTypography variant="caption" color="error">Please Provide title for center</MDTypography>}
        </MDBox>

        <MDBox width="100%" mr={2}>
          <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">Email</MDTypography>
          <MDInput type="email" fullWidth name="email" value={center.email} onChange={changeHandler} error={errors.emailerror} />
          {errors.emailerror && <MDTypography variant="caption" color="error">Please provide Center email</MDTypography>}
        </MDBox>

        <MDBox width="100%" mr={2}>
          <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">Address</MDTypography>
          <MDInput type="text" fullWidth name="address" value={center.address} onChange={changeHandler} error={errors.addresserror} />
          {errors.addresserror && <MDTypography variant="caption" color="error">Please Provide Center Address</MDTypography>}
        </MDBox>
      </MDBox>

      <MDBox display="flex" flexDirection="row" mt={3} mb={3}>
        <MDBox width="32%" mr={2}>
          <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">City</MDTypography>
          <FormControl fullWidth>
            <Select
              name="city"
              value={center.city}
              onChange={changeHandler}
              sx={{ height: '45px' }}
              IconComponent={() => (
                <IconButton>
                  <ArrowDropDown />
                </IconButton>
              )}
            >
              {cityOptions.map((city) => (
                <MenuItem key={city} value={city}>
                  {city}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>
        <MDBox width="32%" mr={2}>
          <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">Country</MDTypography>
          <FormControl fullWidth>
            <Select name="country"
              value={center.country}
              onChange={changeHandler}
              sx={{ height: '45px' }}
              IconComponent={() => (
                <IconButton>
                  <ArrowDropDown />
                </IconButton>
              )}
            >
              {countryOptions.map((country) => (
                <MenuItem key={country} value={country}>{country}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>

      </MDBox>
    </MDBox>
  );
});
export default CenterForm;
